import { Box, BoxProps, Image } from "@chakra-ui/react";
import UploadIcon from "@root/assets/icons/UploadIconNew.svg";

export function UploadIconNew({ ...props }: BoxProps) {
  return (
    <Box cursor={"pointer"} {...props}>
      <Image src={UploadIcon} />
    </Box>
  );
}
